import { Typography, Box, CircularProgress} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { add, CURRENCY, displayMoney, Money, moneyToMetric } from '../../../../utils/money';
import { Expense, ExpenseStatus } from '../../../../interfaces/delivery-company/expenses';
import { PieChart } from '@mui/x-charts';
import { center, normalizeBySum } from '../cash-flow/utils';
import Decimal from 'decimal.js';
import { generatePieData } from './utils';
import { DoubleDate } from '../../../common/double-date-picker/double-date-picker.interfaces';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import { useSnackBar } from '../../../../contexts/snackbar';
import axios, { AxiosResponse } from 'axios';
import Grid2 from '@mui/material/Unstable_Grid2';

interface ExpensesPieChartProps {
    expenses?: Expense[];
    status: ExpenseStatus;
    label: string;
}

function ExpensesPieChart({expenses, status, label}: ExpensesPieChartProps) {
    

    const categoryToAmounts = new Map()
    
    
    if (expenses) expenses.forEach(item => categoryToAmounts.set(item.category!.label, categoryToAmounts.has(item.category!.label) ? add(categoryToAmounts.get(item.category!.label), item.expense) : item.expense))

    const data : [string, Money[]][] = Array.from(categoryToAmounts.entries());
    const totalAmount = data.map(e => e[1]).reduce((curr, next) => add(curr, next), [] as Money[])

    data.sort((a, b) => {
        const metricA = moneyToMetric(a[1]);
        const metricB = moneyToMetric(b[1]);
        return metricA.sub(metricB).toNumber(); // Descending order
    });


    const pieData = generatePieData(data, status == ExpenseStatus.PENDING ? "orange" : "green" )


    return  <Box sx={{ mt: 4, height: '100%', width: '100%' }}>
            <Typography variant="h6" sx={{  mt: 1, mb: 4, textAlign: center }} align='center'>
                {expenses ? <>{label}:  {displayMoney(totalAmount)}</> : <>{label} <CircularProgress size={20} /></>}
            </Typography>
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
        >
          {expenses && expenses.length > 0 ? <>
             <PieChart
            series={[
              {
                data: pieData,
                 valueFormatter: (value, context) => pieData[context.dataIndex].formattedValue,
                innerRadius: 60,
                outerRadius: 100,
                paddingAngle: 4,
                cornerRadius: 4,
                highlightScope: { faded: 'global', highlighted: 'item' },
                faded: {
                  innerRadius: 30,
                  additionalRadius: -30,
                  color: 'gray',
                },
              },
            ]}
            margin={{ right: 250 }}
            slotProps={{
              legend: {
                direction: 'column',
                position: {
                  horizontal: 'right',
                  vertical: 'middle',
                },
              },
            }}
            width={400}
            height={200}
          />
          
          </> :
             <Box
                sx={{
                    height: "300px",
                    width: "100%",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px dashed #ccc',
                    borderRadius: 2,
                    p: 2,
                }}
                >
                    {
                        !expenses ? <CircularProgress /> :  <Typography variant="body1" color="text.secondary">
                    No expenses 🎉
                </Typography>
                    }
               
            </Box>
                
        }
       
        </div>
      </Box>
}

export interface Summary {
    paid: Expense[];
    pending: Expense[];
}

interface ExpensesSummaryProps {
    dateFilter: DoubleDate,
    summary?: Summary,
}

function ExpensesSummary({dateFilter, summary}:ExpensesSummaryProps) {
    

    let dateRangeLabel = ``
    if (dateFilter) {
        if (dateFilter.startDate != null && dateFilter.endDate != null) {
                dateRangeLabel = `between ${dateFilter.startDate.format("DD-MM-YYYY")} and ${dateFilter.endDate.format("DD-MM-YYYY")}`
            } else if (dateFilter.startDate != null) {
                dateRangeLabel = `since ${dateFilter.startDate.format("DD-MM-YYYY")}`
            } else if (dateFilter.endDate != null) {
                dateRangeLabel = `until ${dateFilter.endDate.format("DD-MM-YYYY")}`
            }
    }
   
    const pendingExpensesLabel = `Pending expenses ${dateRangeLabel}`
    const paidExpensesLabel = `Expenses paid ${dateRangeLabel}` 

    return    <Grid2 container spacing={2}>
                      <Grid2 xs={12} md={6}>
                  <ExpensesPieChart label={pendingExpensesLabel} expenses={summary?.pending}   status={ExpenseStatus.PENDING} />
                </Grid2>
        
                <Grid2 xs={12} md={6}>
                    <ExpensesPieChart label={paidExpensesLabel} expenses={summary?.paid}  status={ExpenseStatus.PAID} />
                </Grid2>
              </Grid2>
              

}

export default ExpensesSummary;